<template>
  <div class="container">
    <div class="sc-message--text" :style="messageColors">
      <p class="sc-message--text-content" v-html="messageText"></p>
      <p v-if="message.data.meta" class='sc-message--meta' :style="{color: messageColors.color}">{{message.data.meta}}</p>
    </div>
    <div v-if="optionSelected === null" class="select-wrapper">
      <div class="select-boxed" @click="openOptions"></div>
      <select class="select2" :disabled="lastMessage === false">
        <option></option>
      </select>
    </div>
  </div>
</template>

<script>
import escapeGoat from 'escape-goat'
import store from "./../store/"

export default {
  props: {
    message:{
      type: Object,
      required: true
    },
    messageColors: {
      type: Object,
      required: true
    },
    messageStyling: {
      type: Boolean,
      required: true
    },
    chatbotColors: {
      type: Object,
      required: true
    },
    lastMessage: {
      type: Boolean,
      default: true
    },
  },
  data() {
    return {
      store,
      optionSelected: null,
      selector: null
    }
  },
  computed: {
    messageText() {
      const escaped = this.me
        ? escapeGoat.escape(this.message.data.text)
        : this.message.data.text;

      return escaped;
    }
  },
  mounted () {
    const url = this.message.data.metadata.route_choice_ajax;
    const params = this.message.data.metadata.params_choice_ajax || {};

    if (url && params) {
      this.mountSelectWithAjax(url, params);
    }
  },
  methods: {
    mountSelectWithAjax (url, params) {
      this.selector = window.jQuery('.select2').select2({
        placeholder: '- Selecione -',
        width: '100%',
        ajax: {
          url,
          data: (defaultParams) => {
            var query = {
              search: defaultParams.term,
              conversa_token: this.$store.state.conversaToken,
              ...params
            }

            return query;
          },
          dataType: 'json',
          delay: 500
        },
        minimumInputLength: 2,
        language: 'pt-BR'
      });

      this.selector.on('change', () => {
        const data = this.selector.select2('data')[0];
        this.selectOption({
          key: data.id,
          value: data.text
        });
      });

      window.jQuery('.select2').one('select2:open', () => {
        window.jQuery('input.select2-search__field').prop('placeholder', 'Buscar por...');
      });
    },
    selectOption (option) {
      this.optionSelected = option;

      window.EventBus.$emit('ON_MESSAGE_WAS_SENT', {
        author: 'me',
        type: 'text',
        editarFluxoInteracaoToken: this.$store.state.editarFluxoInteracaoToken,
        bot: true,
        data: { key: option.key, text: option.value }
      });
    },
    openOptions () {
      setTimeout(() => {
        this.selector.select2('open');
      }, 100);
    }
  }
}
</script>

<style scoped>
a.chatLink {
  color: inherit !important;
}
.container {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
}
.select-wrapper {
  width: 100%;
  margin-top: 10px;
  position: relative;
}
.select-boxed {
  width: 100%;
  height: 39px;
  position: absolute;
  z-index: 1;
}
</style>
